.trigger {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.card {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  background: var(--nexus-glass-surface);
  color: var(--nexus-text);
  border: 1px solid var(--nexus-border);
  border-radius: var(--nexus-radius-surface);
  box-shadow: var(--nexus-shadow-dropdown);
  padding: var(--nexus-space-sm) var(--nexus-space-md);
  font-size: var(--nexus-text-sm);
  line-height: 1.45;
  backdrop-filter: blur(8px);
  /* width: max-content lets the card use its natural content width up to
     max-width. Without it, position:fixed + left:X causes the box's available
     width to shrink to viewport_width - X, which makes triggers near the right
     edge force the card to wrap extremely narrow. */
  width: max-content;
}

.cardAbove {
  transform: translate(-50%, -100%);
  animation: tooltipFadeInAbove 120ms ease-out;
}

.cardBelow {
  transform: translateX(-50%);
  animation: tooltipFadeInBelow 120ms ease-out;
}

/* Horizontal placements: the card is centred on the trigger vertically, so the
   anchor `top` is its middle rather than an edge. */
.cardRight {
  transform: translateY(-50%);
  animation: tooltipFadeInRight 120ms ease-out;
}

.cardLeft {
  transform: translate(-100%, -50%);
  animation: tooltipFadeInLeft 120ms ease-out;
}

@keyframes tooltipFadeInRight {
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

@keyframes tooltipFadeInLeft {
  from {
    opacity: 0;
    transform: translate(-100%, -50%) translateX(4px);
  }
  to {
    opacity: 1;
    transform: translate(-100%, -50%) translateX(0);
  }
}

@keyframes tooltipFadeInAbove {
  from {
    opacity: 0;
    transform: translate(-50%, -100%) translateY(4px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -100%) translateY(0);
  }
}

@keyframes tooltipFadeInBelow {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
